export const portfolioItems = [
    {
      id: 1,
      title: "GETT Easy Booking Application",
      category: "App",
      Role: `UI/UX Designer`,
      tools:"Figma, AI Illustrator, Canva",
      imageUrl: "assets/img/portfolio/portfolio1/1.png",
      images: [
        "assets/img/portfolio/portfolio1/1.png",
        "assets/img/portfolio/portfolio1/3.png",
        "assets/img/portfolio/portfolio1/4.png",
        "assets/img/portfolio/portfolio1/5.png",
        "assets/img/portfolio/portfolio1/6.png",
        "assets/img/portfolio/portfolio1/7.png",
        "assets/img/portfolio/portfolio1/8.png",
        "assets/img/portfolio/portfolio1/9.png",
        "assets/img/portfolio/portfolio1/10.png",
        "assets/img/portfolio/portfolio1/11.png",
        "assets/img/portfolio/portfolio1/12.png",
        "assets/img/portfolio/portfolio1/13.png",
        "assets/img/portfolio/portfolio1/14.png",      
        "assets/img/portfolio/portfolio1/15.png",
        "assets/img/portfolio/portfolio1/16.png",   
        "assets/img/portfolio/portfolio1/17.png",
      ],
      ProjectUrl: "https://www.behance.net/gallery/198093401/GETT-Easy-Booking-Application-A-Case-Study-(UIUX)",
      description: `<b>A Case Study (UI/UX)</b> <br />
      GETT Easy aims to revolutionize the hotels, cars, cruises, short-lets, and events booking experience with a web and mobile application designed for any user. This project focuses on delivering an intuitive and visually engaging user interface, catering to the needs of travelers and tourists.
      <br/>... The app streamlines the booking process, offering a seamless reservation system and secure payment gateways, providing users with a hassle-free and efficient way to confirm their stay or use....`
    },
    {
      id: 2,
      title: "CRM Project-Light & Dark Mode",
      category: "Web",      
      Role: `UI/UX Designer`,
      tools:"Figma, Interaction Design",
      imageUrl: "assets/img/portfolio/portfolio2/Cover.png",
      images: [
        "assets/img/portfolio/portfolio2/1.png",
        "assets/img/portfolio/portfolio2/2.png",
      ],
      ProjectUrl: "https://www.behance.net/gallery/198110833/CRM-Project-Light-Dark-Mode",
      description: `In today's hyper-connected digital landscape, effective customer relationship management is imperative for business success.<br/> By leveraging CRM systems, businesses can nurture customer relationships, drive sales growth, and achieve sustainable competitive advantage. From contact management to marketing automation, CRM empowers businesses to deliver exceptional customer experiences and foster long-term loyalty. Embracing CRM as a strategic tool is not merely an option but a necessity for businesses aspiring to thrive in the digital age.
      `
    },
    {
      id: 3,
      title: "Petal & Thread- Brand Guidelines Presentation",
      category: "Card",
      tools: "Adobe Creative Suite, Figma, Canva",
      Role: "Brand / Product Designer",
      imageUrl: "assets/img/portfolio/portfolio3/cover.jpg",
      images: [
        "assets/img/portfolio/portfolio3/1.jpg",
        "assets/img/portfolio/portfolio3/2.jpg",
        "assets/img/portfolio/portfolio3/3.jpg",
        "assets/img/portfolio/portfolio3/4.jpg",
        "assets/img/portfolio/portfolio3/5.jpg",
        "assets/img/portfolio/portfolio3/6.jpg",
        "assets/img/portfolio/portfolio3/7.jpg",
        "assets/img/portfolio/portfolio3/8.jpg",
        "assets/img/portfolio/portfolio3/9.jpg",
        "assets/img/portfolio/portfolio3/10.jpg",
        "assets/img/portfolio/portfolio3/11.jpg",
        "assets/img/portfolio/portfolio3/12.jpg",
      ],
      description: `
      As a brand and UI/UX designer, crafting a compelling and cohesive brand guidelines presentation for "Petal & Thread" involves a blend of creativity, strategic thinking, and proficiency with various design tools.
      <br/>
      <b>Project Overview:</b><br/>
      Petal & Thread is a brand dedicated to offering exquisite, handmade fabrics and floral arrangements. The brand guidelines presentation is crucial in maintaining consistency across all visual and communicative elements, ensuring the brand’s identity is easily recognizable and resonates with its target audience.
      <br/>
      <b>Key Components of the Brand Guidelines Presentation:</b><br/>
      - Brand Identity: Defining the core elements of the brand, including mission, vision, and values.<br/>
      - Logo Usage: Guidelines on the correct use of the logo, including color variations, spacing, and placement.<br/>
      - Color Palette: A cohesive set of colors that represent the brand’s personality.<br/>
      - Typography: Font styles and hierarchies for different types of communication.<br/>
      - Imagery Style: Guidelines for photography, illustrations, and graphic elements that align with the brand’s aesthetic.<br/>
      - Voice and Tone: Instructions on how to maintain a consistent voice in all brand communications.<br/>
      - Application Examples: Real-life examples of how the brand elements should be applied across various media.
        `
      },
      {
        id: 4,
        title: "Neftify - NFT Marketplace Dashboard",
        category: "Web",
        tools: "Figma",
        Role: "UI/UX Designer",
        imageUrl: "assets/img/portfolio/portfolio4/Frame.png",
        images: [
          "assets/img/portfolio/portfolio4/1.png",
          "assets/img/portfolio/portfolio4/2.png",
        ],
        ProjectUrl: "https://www.behance.net/gallery/198363407/Neftify-NFT-Marketplace-Dashboard-",
        description: `
        <b>Welcome to Neftify – Your Ultimate NFT Marketplace Dashboard!</b><br/>
        Neftify is a cutting-edge NFT marketplace dashboard designed to provide a seamless and intuitive user experience for both buyers and sellers of digital assets. Built with React, this platform stands out with its sleek design and user-centric functionalities.<br/><br/>
        <b>Innovative NFT Management</b><br/>
        Our platform simplifies the complex world of NFTs with a clean and user-friendly interface, ensuring users can navigate and manage their digital assets effortlessly. Neftify empowers artists, collectors, and investors with the tools they need to thrive in the NFT ecosystem.<br/><br/>
        <b>Seamless Transactions and Stunning Visuals</b><br/>
        With streamlined navigation and visually stunning dashboards, Neftify offers an unparalleled experience in buying, selling, and managing NFTs. The platform's design ensures that every interaction is smooth and efficient.<br/><br/>
        <b>Why Choose Neftify?</b><br/>
        - <b>User-Centered Design:</b> Focused on making NFT transactions easy and enjoyable.<br/>
        - <b>Engaging Interfaces:</b> Visually appealing designs that enhance user interaction.<br/>
        - <b>Seamless Experience:</b> Effortlessly navigate through the marketplace, managing and trading NFTs with ease.<br/><br/>
        Join Neftify today and elevate your NFT marketplace experience to new heights.
      `
      },
      {
        id: 5,
        title: "SkillForge - Online E-Learning Educational App",
        category: "Web",
        tools: "Figma, Adobe XD",
        Role: "UI/UX Designer",
        imageUrl: "assets/img/portfolio/portfolio5/mock.png",
        images: [
          "assets/img/portfolio/portfolio5/3.png",
          "assets/img/portfolio/portfolio5/1.png",
          "assets/img/portfolio/portfolio5/2.png",
          "assets/img/portfolio/portfolio5/4.png",
        ],
        ProjectUrl: "https://www.behance.net/gallery/198115213/SkillForge-Online-E-Learning-Educational-App",
        description: `
          <b>Welcome to SkillForge – Your Gateway to Unparalleled Online Learning Experiences!</b><br/>
          SkillForge is a meticulously designed educational platform tailored for educators, trainers, and institutions. Our web and mobile solution, built with React, meets diverse educational needs and ensures a seamless and intuitive user experience.<br/><br/>
          <b>Immersive Learning Environment</b><br/>
          Our platform offers a user-centered design that makes learning and teaching engaging and immersive. SkillForge empowers educators to create exceptional online courses effortlessly.<br/><br/>
          <b>Intuitive Navigation and Stunning Interfaces</b><br/>
          With streamlined navigation and visually appealing interfaces, SkillForge is your essential toolkit for crafting captivating educational experiences. Whether you're a seasoned web designer, an educational institution, or an aspiring online educator, SkillForge elevates your online education endeavors to new heights.<br/><br/>
          <b>Why Choose SkillForge?</b><br/>
          - <b>User-Centered Design:</b> Focused on making the learning process easy and enjoyable.<br/>
          - <b>Engaging Interfaces:</b> Visually appealing designs that capture and retain learners' attention.<br/>
          - <b>Seamless Experience:</b> Effortlessly navigate through the platform, creating and accessing content with ease.<br/><br/>
          Join SkillForge today and transform your online education experience into something extraordinary.
        `
      },
      
      {
        id: 6,
        title: "GlamourGo E-commerce App",
        category: "App",
        tools: "Figma",
        Role: "UI/UX Product Designer",
        imageUrl: "assets/img/portfolio/portfolio6/cover.png",
        images: [
          "assets/img/portfolio/portfolio6/1.jpg",
          "assets/img/portfolio/portfolio6/2.jpg",
          "assets/img/portfolio/portfolio6/3.jpg",
          "assets/img/portfolio/portfolio6/4.jpg",
          "assets/img/portfolio/portfolio6/5.jpg",
          "assets/img/portfolio/portfolio6/6.jpg",
          "assets/img/portfolio/portfolio6/7.jpg",
          "assets/img/portfolio/portfolio6/8.jpg",
          "assets/img/portfolio/portfolio6/9.jpg",
          "assets/img/portfolio/portfolio6/10.jpg",
        ],
        description: `
        Experience the future of online shopping with GlamourGo E-commerce App. Our meticulously designed product mockups offer a glimpse into the seamless and visually captivating shopping experience that awaits you. From chic fashion accessories to luxurious skincare essentials, GlamourGo brings the world of glamour right to your fingertips.
        `
      },
      {
        id: 7,
        title: "Project Ocean - Conservation Campaign",
        category: "Web",
        tools: "Figma, Framer, Illustrator",
        Role: "Lead Brand & UX Designer",
        imageUrl: ["assets/img/portfolio/ocean.png"],
        images: [],
        detailsPageUrl: "/ocean",
        description: "A full-scale non-profit ocean conservation campaign case study."
      },
      {
        id: 8,
        title: "Vestly - Smart Investing App",
        category: "App",
        tools: "Figma, React, UI Design",
        Role: "UI/UX Designer",
        imageUrl: ["assets/img/portfolio/vestly1.png"],
        images: [],
        detailsPageUrl: "/vestly",
        description: "A wealth management app case study for first-time investors."
      }
    // Add more portfolio items here as needed
  ].map(item => ({
    ...item,
    detailsPageUrl: item.detailsPageUrl ?? `/portfolio/${item.title}` // Dynamically generate details page URL
  }));
  